import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  AudioLines,
  Lightbulb,
  Thermometer,
  Settings,
  Loader2,
} from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useConfiguration } from "@/hooks";
import { Navigate } from "react-router";
import { useUserDetails } from "@/hooks";
import { GeneralConfiguration } from "./general-configuration";
import { NoiseDoseConfiguration } from "./noise-dose-configuration";
import { TemperatureConfiguration } from "./temperature-configuration";
import { LightingConfiguration } from "./lighting-configuration";


export default function ConfigurationPage() {
  // query hook
  const { data: configuration, isLoading } = useConfiguration();
  const { data: user } = useUserDetails();

  if (user?.type === "anonymous") {
    return <Navigate to="/inicia-sesion?redirect=configuracion" />;
  }

  return (
    <div className="grid gap-3 w-full">
      <div>
        <h1 className="text-lg font-semibold">Configuración de Reportes</h1>
        <p className="text-muted-foreground text-xs">
          Configura los parámetros para los reportes de ruido dosis, temperatura
          y iluminación.
        </p>
      </div>

      <Separator />

      {!configuration ? (
        <div className="flex justify-center items-center h-full">
          <Loader2 className="size-4 animate-spin" />
        </div>
      ) : (
        <Tabs defaultValue="general">
          <TabsList className="grid grid-cols-4">
            <TabsTrigger value="general">
              <Settings className="size-4 mr-2" />
              General
            </TabsTrigger>
            <TabsTrigger value="noise_dose">
              <AudioLines className="size-4 mr-2" />
              Ruido dosis
            </TabsTrigger>
            <TabsTrigger value="temperature">
              <Thermometer className="size-4 mr-2" />
              TGBH
            </TabsTrigger>
            <TabsTrigger value="lighting">
              <Lightbulb className="size-4 mr-2" />
              Iluminación
            </TabsTrigger>
          </TabsList>

          {isLoading ? (
            <div className="flex justify-center items-center h-full">
              <Loader2 className="size-4 animate-spin" />
            </div>
          ) : (
            <>
              <TabsContent value="general">
                <GeneralConfiguration />
              </TabsContent>
              <TabsContent value="noise_dose">
                <NoiseDoseConfiguration />
              </TabsContent>
              <TabsContent value="temperature">
                <TemperatureConfiguration />
              </TabsContent>
              <TabsContent value="lighting">
              <LightingConfiguration />
              </TabsContent>
            </>
          )}
        </Tabs>
      )}
    </div>
  );
}
